<template>
  <v-dialog v-model="changeTextDialog" max-width="1000px">
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Globalna zmiana tekstów</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" class="ma-3">
        <v-layout row>
          <v-flex xs1 />
          <v-flex xs10>
            <v-autocomplete
              :items="[
                { type: 'task', code: 'Zadanie' },
                { type: 'priority', code: 'Priorytet' },
                { type: 'area', code: 'Obszar' },
              ]"
              label="Wybierz"
              item-text="code"
              item-value="type"
              v-model="changePhrase.type"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs1 />
        </v-layout>
        <v-layout row>
          <v-flex xs1 />
          <v-flex xs10>
            <egranty-text-input-field
              v-model="changePhrase.phraseFrom"
              label="Znajdź"
              name="phraseFrom"
            />
          </v-flex>
          <v-flex xs1 />
        </v-layout>
        <v-layout row>
          <v-flex xs1 />
          <v-flex xs10>
            <egranty-text-input-field
              v-model="changePhrase.phraseTo"
              label="Zamień"
              name="phraseTo"
            />
          </v-flex>
          <v-flex xs1 />
        </v-layout>
      </v-form>
      <v-layout row>
        <v-spacer />
        <v-btn
          @click="changeTexts"
          class="add-project-popup-btn"
          :disabled="
            !changePhrase.type ||
              !changePhrase.phraseFrom ||
              !changePhrase.phraseTo
          "
        >
          Zmień
        </v-btn>
        <v-btn @click="closeDialog" class="add-project-popup-btn">
          Zamknij
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
import { AgencyTask } from "@/api/generated/AgencyTask";

export default {
  name: "TextChanger",

  components: {
    EgrantyTextInputField,
  },

  methods: {
    closeDialog() {
      this.$emit("closeTextChangerDialog");
    },
    changeTexts() {
      AgencyTask.postChangePhrase(
        this,
        this.$route.params.id,
        this.changePhrase,
        () => {
            this.$emit("refresh");
            this.closeDialog();
        },
        (errorResponse) => {
          if (errorResponse.status === "NOT_ACCEPTABLE") {
            this.$emit("textChangeError", errorResponse);
            this.closeDialog();
          }
        }
      );
    },
  },

  data() {
    return {
      changePhrase: {
        phraseFrom: null,
        phraseTo: null,
        type: null,
      },
      show: true,
    };
  },
  props: {
    changeTextDialog: { type: Boolean, default: false },
  },
};
</script>
<style scoped></style>
